import Image from '@segment/matcha/components/Image'

import buildDeeperPng2x from './assets/BuildDeeper@2x.png'
import buildDeeperWebp from './assets/BuildDeeper.webp'
import buildDeeperWebp2x from './assets/BuildDeeper@2x.webp'

const BuildDeeperImage = () => {
  return (
    <picture>
      <source type="image/webp" srcSet={`${buildDeeperWebp}, ${buildDeeperWebp2x} 2x`} />
      <Image
        width="640"
        height="608"
        src={buildDeeperPng2x}
        alt="Illustration: Make it a continuous conversation"
        loading="lazy"
      />
    </picture>
  )
}

export default BuildDeeperImage
